export const durations = [
  {
    title: "Video Duration",
    isExpanded: true,
    content: [
      {
        duration: "0-2 Hours",
        rating: "9.4k",
      },
      {
        duration: "3-5 Hours",
        rating: "4.4k",
      },
      {
        duration: "4-6 Hours",
        rating: "3.8k",
      },
      {
        duration: "12+ Hours",
        rating: "1k",
      },
    ],
  },
];
export const categories = [
  {
    title: "Categories",
    isExpanded: true,
    content: [
      {
        category: "Design",
        rating: "3.2k",
      },
      {
        category: "Programming",
        rating: "1.4k",
      },
      {
        category: "Business & Marekting",
        rating: "809",
      },
      {
        category: "Finance",
        rating: "548",
      },
      {
        category: "Music & Film",
        rating: "1.9k",
      },
      {
        category: "Writing",
        rating: "700",
      },
    ],
  },
];

export const levels = [
  {
    title: "Level",
    isExpanded: false,
    content: ["All Levels", "Beginner", "Intermediate", "Advanced"],
  },
];

export const software = [
  {
    title: "Software",
    isExpanded: false,
    content: ["Figma", "Corel Draw", "Adobe", "Canva", "PS6"],
  },
];

export const languages = [
  {
    title: "Language",
    isExpanded: false,
    content: ["English", "Hindi", "Spanish", "Arabic"],
  },
];

export const ratings = [
  {
    title: "Rating",
    content: [
      {
        star: 4.5,
    
        ratingPoint: '4.5',
        totalRating: '5.8k'
      },
      {
        star: 3.5,
       
        ratingPoint: '3.5',
        totalRating: '1.2K'
      },
      {
        star: 3.0,
      
        ratingPoint: '3.0',
        totalRating: '867'
      },
    ],
  },
];
